<script>
import NextToPlaySquare from './NextToPlaySquare.vue';
import NextToPlayWide from './NextToPlayWide.vue';
// + Implicit dependency on ./state/NextToPlay.js

// @vue/component
const comp = {
  components: {
    NextToPlaySquare,
    NextToPlayWide,
  },
  props: {
    layout: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const store = this.$store;
    const UPDATE_INTERVAL = 30000;

    // auto update component every 30secs
    setInterval(() => {
      store.dispatch('NextToPlay/fetchNextToPlay');
    }, UPDATE_INTERVAL);
  },
  getSSRActions(context, getComponentActions) {
    // Ask the kids for their actions (as this component shouldn't know what they need)
    return getComponentActions(context, Object.values(comp.components));
  },
};

export default comp;
</script>

<template>
  <div class="next-to-play-base">
    <div v-if="layout==='alwaysWide'" class="alwaysWide">
      <NextToPlayWide/>
    </div>

    <div v-else-if="layout==='alwaysSquare'" class="alwaysSquare">
      <NextToPlaySquare/>
    </div>

    <div v-else>
      <NextToPlayWide/>
      <NextToPlaySquare/>
    </div>
  </div>
</template>
